import { Stack } from "@mui/material";
import React from "react";
import { TextInput } from "~/components/ui/core/TextInput";

type Event = {
  target: {
    name?: string;
    value: { min: number | null; max: number | null };
  };
};

export type CompanySize = { min: number | null; max: number | null };

type Props = {
  name?: string;
  value: CompanySize | undefined;
  dense?: boolean;
  disabled?: boolean;
  direction?: "row" | "column";
  onChange: (event: Event) => void;
};

export const CompanySizeSelector: React.FC<Props> = ({
  name,
  value,
  direction = "row",
  dense = true,
  disabled = false,
  onChange,
}) => {
  return (
    <Stack direction={direction} spacing={2}>
      <TextInput
        dense={dense}
        withPrefix="Min"
        disabled={disabled}
        min={0}
        placeholder="0"
        type="number"
        value={value?.min ?? ""}
        onChange={(event) => {
          onChange({
            target: {
              name,
              value: {
                min: event.target.value ? parseInt(event.target.value) : null,
                max: value?.max ?? null,
              },
            },
          });
        }}
      />
      <TextInput
        dense={dense}
        withPrefix="Max"
        disabled={disabled}
        min={1}
        placeholder="100"
        type="number"
        value={value?.max ?? ""}
        onChange={(event) => {
          onChange({
            target: {
              name,
              value: {
                min: value?.min ?? null,
                max: event.target.value ? parseInt(event.target.value) : null,
              },
            },
          });
        }}
      />
    </Stack>
  );
};
